import { Component, OnInit } from '@angular/core';
import {AdminService} from "../../services/admin-service";
import {RawSoldPlate} from "../../models/registration";

@Component({
  selector: 'pla-admin-sold-search',
  templateUrl: './admin-sold-search.component.html',
  styleUrls: ['./admin-sold-search.component.scss']
})
export class AdminSoldSearchComponent implements OnInit {

  public plateStyle: string = 'dateless';
  public platePrefix: string = '';
  public plateNumbers: string = '';
  public plateLetters: string = '';

  displayedColumns: string[] = ['registration', 'sold_price', 'sold_date', 'seller'];
  public results: RawSoldPlate[] = [];

  constructor(private adminService: AdminService) { }

  ngOnInit(): void {
  }

  public plateStyleChanged(event: any): void {
    this.plateStyle = event.value;
  }

  public searchPlates(): void {
    // check if all fields are empty
    if (!this.platePrefix && !this.plateNumbers && !this.plateLetters) {
      alert('Enter at least one search parameter.');
      return;
    }
    console.log(this.plateStyle, this.platePrefix, this.plateNumbers, this.plateLetters);
    this.adminService.BYOSoldPlates(this.plateStyle, this.platePrefix.toUpperCase().replace('%', '%25'), this.plateNumbers.toUpperCase().replace('%', '%25'), this.plateLetters.toUpperCase().replace('%', '%25'), (res) => {
      if (res) {
        if (res.length > 7000) {
          alert(`Too many results found (${res.length}). Please refine your search criteria. Showing top 1000`);
          this.results = [...res].splice(0, 1000);
          return;
        }
        this.results = [...res];
      } else {
        alert('No results found or an error occurred.');
      }
    });
  }

  public exportResults(): void {
    // res as csv
    if (this.results.length === 0) {
      alert('No results to export.');
      return;
    }
    const csvContent = this.results.map((r: RawSoldPlate) => {
      return `${r.formattedRegistration},${(Number.parseInt(r.sold_price) / 100).toFixed(2)},${r.sold_date},${r.seller || ''}`;
    }).join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', `${this.plateStyle}_${this.platePrefix}_${this.plateNumbers}_${this.plateLetters}_sold_plates.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    alert('Results exported as .csv');
  }
}
